<template lang="pug">
v-list-item-content
  v-list-item-title.ml-2
    span(:style="labelStyles") {{ text }}
</template>

<script lang="ts">
import { defineComponent } from "vue"
import THEME from "../constants/theme"

const {
  typography: { fontFamily, fontWeightRegular, rootFontSize },
  colors: {
    light: { textColor },
  },
} = THEME

export default defineComponent({
  name: "AttachmentListItemContent",
  props: { text: { type: String, required: true } },
  setup() {
    const labelStyles = {
      color: textColor,
      fontFamily,
      fontWeight: fontWeightRegular,
      fontSize: `${rootFontSize}px`,
      lineHeight: `${rootFontSize * 0.8 * 1.5}px`,
      textDecoration: "underline",
    }
    return {
      labelStyles,
    }
  },
})
</script>
